import { createElement, ElementType } from 'react';

// Helper functions to safely get step properties
export const getStepNumber = (step: unknown): number =>
  (step as { step: number }).step;

export const getStepTitle = (step: unknown): string =>
  (step as { title: string }).title;

export const getStepMobileName = (step: unknown): string | undefined => {
  const s = step as { mobileName?: string };
  return s.mobileName;
};

export const getStepRoute = (step: unknown): string | undefined => {
  const s = step as { route?: string };
  return s.route;
};

export const getStepIcon = (step: unknown): ElementType | undefined => {
  const s = step as { icon?: ElementType };
  return s.icon;
};

// Icon rendering helper
export const renderIcon = (
  step: unknown,
  stepNumber: number,
  getColor: (stepNumber: number) => string,
  showIcons: boolean,
  showNumbers: boolean
) => {
  const IconComponent = getStepIcon(step);
  if (!showIcons || !IconComponent) return null;

  return createElement(IconComponent, {
    width: '14px',
    height: '14px',
    fill: getColor(stepNumber),
    style: { marginRight: showNumbers ? '0' : '8px' }
  });
};

// Dynamic breakpoint configuration helper
export const getBreakpointConfig = (stepsCount: number) => {
  // Switch to mobile mode earlier for many steps
  if (stepsCount > 4) {
    return { base: true, xl: false }; // Switch at xl (1280px) instead of md (768px)
  }
  if (stepsCount > 3) {
    return { base: true, md: false, lg: false }; // Switch at lg (992px) instead of md (768px)
  }
  return { base: true, md: false }; // Default behavior for 3 or fewer steps
};

// Note: getThemeColors helper is kept in component due to complex typing
